import Vue from "vue";
Vue.filter("formatDateRu", (value) => {
  if (!value) return "";
  const date = new Date(value);
  return (
    date.getUTCDate().toString().padStart(2, "0") +
    "." +
    (date.getUTCMonth() + 1).toString().padStart(2, "0") +
    "." +
    date.getUTCFullYear() +
    " " +
    date.getUTCHours().toString().padStart(2, "0") +
    ":" +
    date.getUTCMinutes().toString().padStart(2, "0") +
    " GMT"
  );
});
